import { LexerTypes } from "../../text/lexer/LexerType";
import { ParserPhase } from "../../text/lexer/parsing/ParserPhase";
import { SourceInfo } from "../../text/lexer/parsing/SourceInfo";
import { RJParser } from "../RJParser";

export class RJCheckUnknowns extends ParserPhase<RJParser>
{
  static readonly phaseInfo = "RJ Check Unknowns";
  get phaseInfo(){ return RJCheckUnknowns.phaseInfo; }

  process()
  {
    let unknowns = this.parser.lexing.events.filter( e => e.isType( LexerTypes.ANY_SYMBOL ) );
    
    for ( let u of unknowns )
    {
      let match = u.getMatch( this.parser.source );
      this.parser.error( "Unexpected symbol: " + match, SourceInfo.fromEvent( u ) );
    } 

  }
} 